export const initHeader = () => {
  // 1. Mobile Menu Toggle & Drawer Controls
  const mobileToggle = document.querySelector('.site-header__mobile-toggle');
  const mobileClose = document.querySelector('.site-header__mobile-close');
  const backdrop = document.querySelector('.site-header__backdrop');
  const mainNav = document.querySelector('.main-nav-pill');

  function openMobileMenu() {
    if (!mainNav) return;
    mainNav.classList.add('is-active');
    if (mobileToggle) {
      mobileToggle.classList.add('is-active');
      mobileToggle.setAttribute('aria-expanded', 'true');
    }
    if (backdrop) {
      backdrop.classList.add('is-active');
    }
    document.body.style.overflow = 'hidden';
    if (mobileClose) {
      setTimeout(() => mobileClose.focus(), 50);
    }
  }

  function closeMobileMenu() {
    if (!mainNav) return;
    const wasActive = mainNav.classList.contains('is-active');
    mainNav.classList.remove('is-active');
    if (mobileToggle) {
      mobileToggle.classList.remove('is-active');
      mobileToggle.setAttribute('aria-expanded', 'false');
      if (wasActive) {
        mobileToggle.focus();
      }
    }
    if (backdrop) {
      backdrop.classList.remove('is-active');
    }
    document.body.style.overflow = '';
  }

  if (mobileToggle && mainNav) {
    mobileToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isExpanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  if (mobileClose) {
    mobileClose.addEventListener('click', (e) => {
      e.stopPropagation();
      closeMobileMenu();
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', () => {
      closeMobileMenu();
    });
  }

  // Helper to close a top-level item and its nested submenus
  function closeTopLevelItem(item) {
    item.classList.remove('is-open');
    const link = item.querySelector(':scope > a');
    if (link) {
      link.setAttribute('aria-expanded', 'false');
      link.blur();
    }
    item
      .querySelectorAll('.menu-item-has-children.is-open')
      .forEach((nested) => {
        nested.classList.remove('is-open');
        const nestedL = nested.querySelector(':scope > a');
        if (nestedL) {
          nestedL.setAttribute('aria-expanded', 'false');
          nestedL.blur();
        }
      });
  }

  // 2. Main Nav Items (Desktop & Mobile)
  const allTopLevelItems = document.querySelectorAll(
    '.main-nav-pill .main-nav-pill__list > li',
  );
  const navDropdownItems = document.querySelectorAll(
    '.main-nav-pill .main-nav-pill__list > li.menu-item-has-children',
  );

  // Desktop: when leaving main nav container completely, close everything immediately
  if (mainNav) {
    mainNav.addEventListener('mouseleave', () => {
      if (window.innerWidth >= 1536) {
        allTopLevelItems.forEach((item) => {
          closeTopLevelItem(item);
        });
      }
    });
  }

  // Desktop: hovering ANY top-level item immediately opens it and closes other menus
  allTopLevelItems.forEach((topItem) => {
    topItem.addEventListener('mouseenter', () => {
      if (window.innerWidth >= 1536) {
        allTopLevelItems.forEach((other) => {
          if (other !== topItem) {
            closeTopLevelItem(other);
          }
        });

        if (topItem.classList.contains('menu-item-has-children')) {
          topItem.classList.add('is-open');
          const link = topItem.querySelector(':scope > a');
          if (link) link.setAttribute('aria-expanded', 'true');
        }
      }
    });
  });

  navDropdownItems.forEach((item) => {
    const link = item.querySelector(':scope > a');
    if (!link) return;

    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');

    link.addEventListener('click', (e) => {
      const isOpen = item.classList.contains('is-open');

      e.preventDefault();
      e.stopPropagation();

      // Close other nav dropdowns
      allTopLevelItems.forEach((otherItem) => {
        if (otherItem !== item) {
          closeTopLevelItem(otherItem);
        }
      });

      // Close bells dropdown
      closeBellsDropdown();

      // Toggle current
      if (isOpen) {
        closeTopLevelItem(item);
      } else {
        item.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      }

      link.blur();
    });
  });

  // 3. Level 1 Dropdown Items & Nested Flyout Submenus
  const allLevel1DropdownItems = document.querySelectorAll(
    '.main-nav-pill .main-nav-pill__list > li > .sub-menu > li',
  );
  const nestedDropdownItems = document.querySelectorAll(
    '.main-nav-pill .sub-menu > li.menu-item-has-children',
  );

  // Desktop hover on any Level 1 item: opens flyout if it has children, closes flyouts if hovering direct links
  allLevel1DropdownItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      if (window.innerWidth >= 1536) {
        const siblings =
          item.parentElement?.querySelectorAll(
            ':scope > li.menu-item-has-children',
          ) || [];
        siblings.forEach((sibling) => {
          if (sibling !== item) {
            sibling.classList.remove('is-open');
            const siblingLink = sibling.querySelector(':scope > a');
            if (siblingLink) siblingLink.setAttribute('aria-expanded', 'false');
          }
        });

        if (item.classList.contains('menu-item-has-children')) {
          item.classList.add('is-open');
          const link = item.querySelector(':scope > a');
          if (link) link.setAttribute('aria-expanded', 'true');
        }
      }
    });
  });

  // Click handling for nested items (for mobile accordions and touch)
  nestedDropdownItems.forEach((nestedItem) => {
    const nestedLink = nestedItem.querySelector(':scope > a');
    if (!nestedLink) return;

    nestedLink.setAttribute('aria-haspopup', 'true');
    nestedLink.setAttribute('aria-expanded', 'false');

    nestedLink.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const isNestedOpen = nestedItem.classList.contains('is-open');

      // Close sibling submenus in the same panel
      const siblings =
        nestedItem.parentElement?.querySelectorAll(
          ':scope > li.menu-item-has-children',
        ) || [];
      siblings.forEach((sibling) => {
        if (sibling !== nestedItem) {
          sibling.classList.remove('is-open');
          const siblingLink = sibling.querySelector(':scope > a');
          if (siblingLink) siblingLink.setAttribute('aria-expanded', 'false');
        }
      });

      if (isNestedOpen) {
        nestedItem.classList.remove('is-open');
        nestedLink.setAttribute('aria-expanded', 'false');
      } else {
        nestedItem.classList.add('is-open');
        nestedLink.setAttribute('aria-expanded', 'true');
      }

      nestedLink.blur();
    });
  });

  // 4. Bells Dropdowns (Desktop & Mobile)
  const allBellsDropdowns = document.querySelectorAll(
    '.site-header__action-dropdown[data-dropdown="bells"]',
  );

  function closeAllBellsDropdowns() {
    allBellsDropdowns.forEach((dropdown) => {
      const btn = dropdown.querySelector('.site-header__action-btn--toggle');
      dropdown.classList.remove('is-open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  // Function to highlight currently ongoing lesson based on current time
  function highlightCurrentLesson() {
    if (!allBellsDropdowns.length) return;

    const now = new Date();
    // Monday = 1, ..., Friday = 5, Saturday = 6, Sunday = 0
    const day = now.getDay();
    const isWeekend = day === 0 || day === 6;
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    allBellsDropdowns.forEach((dropdown) => {
      const bellItems = dropdown.querySelectorAll('.site-header__bells-item');
      bellItems.forEach((item) => {
        item.classList.remove('is-current');
        if (isWeekend) return;

        const hoursEl = item.querySelector('.site-header__bells-hours');
        if (!hoursEl) return;

        const hoursText = hoursEl.textContent.trim();
        // Format: "8:00 - 8:45" or "08:00 - 08:45"
        const parts = hoursText.split('-').map((s) => s.trim());
        if (parts.length === 2) {
          const [startH, startM] = parts[0].split(':').map(Number);
          const [endH, endM] = parts[1].split(':').map(Number);

          if (!isNaN(startH) && !isNaN(startM) && !isNaN(endH) && !isNaN(endM)) {
            const startTotal = startH * 60 + startM;
            const endTotal = endH * 60 + endM;

            if (currentMinutes >= startTotal && currentMinutes <= endTotal) {
              item.classList.add('is-current');
            }
          }
        }
      });
    });
  }

  // Initial check and periodic update every minute
  highlightCurrentLesson();
  setInterval(highlightCurrentLesson, 60000);

  allBellsDropdowns.forEach((dropdown) => {
    const btn = dropdown.querySelector('.site-header__action-btn--toggle');
    if (!btn) return;

    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = dropdown.classList.contains('is-open');

      // Close main nav dropdowns
      navDropdownItems.forEach((item) => {
        closeTopLevelItem(item);
      });

      // Close other dropdowns
      allBellsDropdowns.forEach((other) => {
        if (other !== dropdown) {
          other.classList.remove('is-open');
          const otherBtn = other.querySelector('.site-header__action-btn--toggle');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        }
      });

      if (isOpen) {
        dropdown.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        highlightCurrentLesson();
        dropdown.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // 5. Click outside to close all dropdowns & mobile menu
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.main-nav-pill .menu-item-has-children')) {
      navDropdownItems.forEach((item) => {
        closeTopLevelItem(item);
      });
    }

    if (!e.target.closest('.site-header__action-dropdown')) {
      closeAllBellsDropdowns();
    }

    if (
      mainNav &&
      mainNav.classList.contains('is-active') &&
      !e.target.closest('.main-nav-pill') &&
      !e.target.closest('.site-header__mobile-toggle')
    ) {
      closeMobileMenu();
    }
  });

  // 6. Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      navDropdownItems.forEach((item) => {
        closeTopLevelItem(item);
      });
      closeBellsDropdown();
      closeMobileMenu();
    }
  });

  // 7. Scroll listener for header background & bottom bar hide/show
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateHeaderOnScroll = () => {
      const currentScrollY = window.scrollY;

      // 1. Dodawanie/usuwanie klasy is-scrolled dla tła i zmniejszenia paddingu
      if (currentScrollY > 20) {
        siteHeader.classList.add('is-scrolled');
      } else {
        siteHeader.classList.remove('is-scrolled');
      }

      // 2. Obsługa ukrywania/pokazywania site-header__bottom w zależności od kierunku
      if (currentScrollY <= 20) {
        // Na samej górze - oryginalny stan
        siteHeader.classList.remove('is-scrolled-down');
      } else if (currentScrollY > lastScrollY) {
        // Przewijanie w dół - ukrywamy dolną część
        siteHeader.classList.add('is-scrolled-down');
      } else if (currentScrollY < lastScrollY) {
        // Przewijanie do góry - pokazujemy dolną część
        siteHeader.classList.remove('is-scrolled-down');
      }

      lastScrollY = Math.max(0, currentScrollY);
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderOnScroll);
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    updateHeaderOnScroll();
  }
};
